import API from "./APIService"
import BaseService from "./BaseService"

class ClientsService extends BaseService {
	component = null

	constructor(component = null) {
		super()
		this.component = component
	}

	baseServicePath = () => {
		return API.url("clients")
	}
}

export default ClientsService
